import React from 'react';
import { getClassNames } from '../../../utils';
import Icon from '../../Icon';
import { ICON_TYPE_REPLY } from '../../Icon/constants';

function CellWithMessageDate({ date = null, isReplied = true }) {
    const className = getClassNames(
        'table-cell_with_message_date',
        { 'table-cell_with_message_date-replied': isReplied },
    );

    return (
        <div className={className}>
            { isReplied ? <Icon type={ICON_TYPE_REPLY} /> : <br /> }
            <span>{date}</span>
        </div>
    );
}


export default CellWithMessageDate;
